/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

type AssociatedUrl = "web" | "call" | "backend";
const knownHomeserversMap: Record<
  string,
  Record<AssociatedUrl, string>
> = {
  "matrix.winsolutions.ru": {
    web: "element-dev.bots.winsolutions.ru",
    call: "element-call-dev.bots.winsolutions.ru",
    backend: "back.klava.dev.winsolutions.ru",
  },
  "chat.avagroup.ru": {
    web: "klava.chat.avagroup.ru",
    call: "call.chat.avagroup.ru",
    backend: "back.chat.avagroup.ru",
  },
};

export function isKnownHomeserver(homeserver: string): boolean {
  return homeserver in knownHomeserversMap;
}

export function getHomeserverAssociatedDomain(homeserver: string, url: AssociatedUrl): string {
  return knownHomeserversMap[homeserver]?.[url] ?? window.location.host;
}
